/*eslint-disable*/
import { createSlice } from '@reduxjs/toolkit'

// actions
import { fetchUser, updateUser } from '../actions/userProfile'

const initialState = {
    userObj: {
      firstName: '',
      lastName: '',
      gender: '',
      dateOfBirth: '',
      email: '',
      login: '',
      mobilePhone: '',
      status: '',
      created: '',
      activated: '',
      statusChanged: '',
      lastLogin: '',
      lastUpdated: '',
      passwordChanged: '',
      profilePictureSrc: '',
      profession: '',
      city: '',
      state: '',
      zip: '',
      addressLine: '',
      groups: []
    },
    status: 'idle',
    error: null
  }

export const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
        .addCase(fetchUser.pending, (state) => {
          state.status = 'loading'
          state.userObj = {}
          state.error = undefined
        })
        .addCase(fetchUser.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.error = undefined
          state.userObj = action.payload
        })
        .addCase(fetchUser.rejected, (state, action) => {
          state.status = 'failed'
          state.userObj = {}
          state.error = action.error.message
        })
        .addCase(updateUser.pending, (state) => {
          state.status = 'loading'
          state.error = undefined
        })
        .addCase(updateUser.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.userObj = action.payload
          state.error = undefined
        })
        .addCase(updateUser.rejected, (state, action) => {
          state.status = 'failed'
          state.error = action.error.message
        })
    }
  })

  export default userProfileSlice.reducer
